import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {get} from 'bukku/shared/ApiService';

// Read coupon
export function* readRequest() {
    yield takeEvery(actions.COUPON_READ_REQUEST, function* ({ code, isPublic, discountOnly }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const url = isPublic ? '/public/coupons' : '/coupons';
            const response = yield call(get, `${url}/${code}`, {
                discount_only: discountOnly,
            }, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.COUPON_READ_SUCCESS,
                coupon: data.coupon,
            });
        }
        catch (error) {
            yield put({
                type: actions.COUPON_READ_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.COUPON_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.COUPON_READ_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
    ]);
}
